import React from 'react';

// Retro pixel-style golden gaming coin (echoes the logo's gaming wordmark)
// Props: size (px), className
export default function Coin({ size = 24, className = '', spin = false }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      shapeRendering="crispEdges"
      className={`${spin ? 'animate-spin [animation-duration:6s]' : ''} ${className}`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="coin-face" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFE27A" />
          <stop offset="55%" stopColor="#F5B301" />
          <stop offset="100%" stopColor="#C98A00" />
        </linearGradient>
      </defs>

      {/* Outer pixel ring (shadow/edge) */}
      <g fill="#8A5A00">
        <rect x="10" y="2" width="12" height="2" />
        <rect x="6" y="4" width="4" height="2" />
        <rect x="22" y="4" width="4" height="2" />
        <rect x="4" y="6" width="2" height="4" />
        <rect x="26" y="6" width="2" height="4" />
        <rect x="2" y="10" width="2" height="12" />
        <rect x="28" y="10" width="2" height="12" />
        <rect x="4" y="22" width="2" height="4" />
        <rect x="26" y="22" width="2" height="4" />
        <rect x="6" y="26" width="4" height="2" />
        <rect x="22" y="26" width="4" height="2" />
        <rect x="10" y="28" width="12" height="2" />
      </g>

      {/* Coin face */}
      <g fill="url(#coin-face)">
        <rect x="10" y="4" width="12" height="2" />
        <rect x="6" y="6" width="20" height="2" />
        <rect x="4" y="8" width="24" height="2" />
        <rect x="4" y="10" width="24" height="12" />
        <rect x="4" y="22" width="24" height="2" />
        <rect x="6" y="24" width="20" height="2" />
        <rect x="10" y="26" width="12" height="2" />
      </g>

      {/* Highlight */}
      <g fill="#FFF3B0" opacity="0.8">
        <rect x="8" y="6" width="4" height="2" />
        <rect x="6" y="8" width="2" height="4" />
      </g>

      {/* Inner "C" mark — CoinsFlu gaming coin */}
      <g fill="#8A5A00">
        <rect x="12" y="10" width="8" height="2" />
        <rect x="10" y="12" width="2" height="8" />
        <rect x="12" y="20" width="8" height="2" />
        <rect x="18" y="12" width="2" height="2" />
        <rect x="18" y="18" width="2" height="2" />
      </g>
    </svg>
  );
}
